import PaymentManagement from "src/components/feature/PaymentManagement";

const PaymentManagementPage = () => {
  return <PaymentManagement />;
};

export default PaymentManagementPage;
